(ns
  frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.details-and-figures
  (:require
   [frontend.ui.component.lp-portal.card.pdf.view :refer [card]]
   [frontend.ui.component.lp-portal.column.pdf.view :refer [column]]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.table.pdf.view :refer [dynamic-table]]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]))

(defn details-and-figures-pages
  [report-data]
  (concat
   (table/dynamic-table-pages
    {:fund-name (:fund-name report-data) :page-title "Details and figures" :toc-item true}
    "Current Portfolio, €"
    (-> report-data
        :details-and-figures
        :current-portfolio)
    {:full-width?   true
     :odd-color     (theme/color [:pdf :table :odd-color])
     :even-color    (theme/color [:pdf :table :even-color])
     :heading-color (theme/color [:pdf :table
                                  :heading-color])})
   (table/dynamic-table-pages {:fund-name  (:fund-name report-data)
                               :page-title "Details and figures"}
                              "Exited portfolio, €"
                              (-> report-data
                                  :details-and-figures
                                  :exited-portfolio)
                              {:full-width?    true
                               :hidden-columns #{"IQID"}
                               :odd-color      (theme/color [:pdf :table :odd-color])
                               :even-color     (theme/color [:pdf :table :even-color])
                               :heading-color  (theme/color [:pdf :table
                                                             :heading-color])})
   (table/dynamic-table-pages {:fund-name  (:fund-name report-data)
                               :page-title "Details and figures"}
                              "Investment summary, €"
                              (-> report-data
                                  :details-and-figures
                                  :investment-summary)
                              {:full-width?    true
                               :hidden-columns #{"IQID"}
                               :odd-color      (theme/color [:pdf :table :odd-color])
                               :even-color     (theme/color [:pdf :table :even-color])
                               :heading-color  (theme/color [:pdf :table
                                                             :heading-color])})
   (table/dynamic-table-pages {:fund-name  (:fund-name report-data)
                               :page-title "Details and figures"}
                              "Cash flows and assets, €"
                              (-> report-data
                                  :details-and-figures
                                  :cash-flows-and-assets)
                              {:hidden-columns #{"IQID"}
                               :odd-color      (theme/color [:pdf :table :odd-color])
                               :even-color     (theme/color [:pdf :table :even-color])
                               :heading-color  (theme/color [:pdf :table
                                                             :heading-color])})))
